(ns kyber.db.media-player
  (:require [clojure.spec.alpha :as s]))

(def initial-state {})

(s/def ::media-player (s/keys :req-un []))

(defn db->media-player-keys
  [db]
  (keys (get-in db [:media-player])))

(defn db->media-player
  [db player-key]
  (get-in db [:media-player player-key]))

(defn db->media-player-player
  [db player-key]
  (:player (db->media-player db player-key)))

(defn db->media-player-attributes
  [db player-key]
  (:attributes (db->media-player db player-key)))

(defn db->play-on-initialize
  [db player-key]
  (:play-on-initialize (db->media-player db player-key)))
